import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { CompanyService } from 'app/services/models/company.service';
import { RequestTaskService } from 'app/services/models/request-task.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AuthService } from 'app/services/auth.service';

@Component({
  selector: 'app-request-task-create',
  templateUrl: './request-task-create.component.html',
  styleUrls: ['./request-task-create.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RequestTaskCreateComponent implements OnInit {
  @Input() requestTaskId: any;
  @BlockUI('section-block') blockUI: NgBlockUI;

  requestForm!: FormGroup;
  companies: any[] = [];
  companyPersons: any = [];
  selectedPersons: any[] = [];

  date = new Date();

  urgencyLevels = [
    { label: 'Çok Acil', value: 1 },
    { label: 'Acil', value: 2 },
    { label: 'Orta Acil', value: 3 },
    { label: 'Normal', value: 4 }
  ];

  statusList = [
    { label: 'Oluşturuldu', value: 1 },
    { label: 'Yapılıyor', value: 2 },
    { label: 'İptal Edildi', value: 3 },
    { label: 'Tamamlandı', value: 4 }
  ];

  selectedCompany: any = null;
  selectedPerson: any;
  selectedCompanyPerson: any;

  selectedRequestTask: any = {};

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,

  };


  constructor(
    private _coreSidebarService: CoreSidebarService,
    private toastrService: ToastrService,
    private formBuilder: FormBuilder,
    private companyService: CompanyService,
    private requestTask: RequestTaskService,
    private cdr: ChangeDetectorRef,
    public authService:AuthService
  ) {

  }

  async ngOnInit() {
    this.requestForm = this.formBuilder.group({
      title: ['', [Validators.required, Validators.maxLength(100)]],
      description: [''],
      urgency: [4],
      startDate: [this.date],
      companyId: [null],
      companyPersonId: [null],
      personId: [null],
      status: [1]
    });
    const companyDetailListAuthorization = this.authService.isEndpointStatus('GET.Reading.GetAllDetailCompany');
    if(companyDetailListAuthorization)
      await this.getAllCompanies();
  }

  async getAllCompanies() {
    const data = await this.companyService.getAllDetailCompany();
    this.companies = data.filter(p => p.id != 1 && p.id != 2);
    console.log(this.companies)
    const filterCompany = data.find(p => p.id === 1);
    this.companyPersons = filterCompany.persons ?? [];
  }

  onCompanyChange(event) {
    console.log(event)
    this.selectedCompany = event.id;
    console.log(this.selectedCompany);
    const selectedCompany = this.companies?.find(p => p.id === event.id);
    console.log(selectedCompany);
    this.selectedPersons = selectedCompany?.persons ?? [];
  }

  onPersonChange(event: any) {
    this.selectedPerson = this.selectedPersons.find(p => p.id === event.id);
  }

  onCompanyPersonChange(event: any) {
    this.selectedCompanyPerson = this.companyPersons.find(p => p.id === event.id);
  }

  async onSubmit() {
    this.blockUI.start('Görev ekleniyor.');

    if (this.requestForm.valid) {
      console.log(this.requestForm.value);
      const selectedPersonId = this.selectedPerson ? this.selectedPerson.id : null;
      const selectedCompanyPersonId = this.selectedCompanyPerson ? this.selectedCompanyPerson.id : null;


      const data = await this.requestTask.createRequestTask(
        this.requestForm.value.title,
        this.selectedCompany,
        this.requestForm.value.description,
        new Date(this.requestForm.value.startDate),
        selectedPersonId,
        this.requestForm.value.urgency ?? 1,
        selectedCompanyPersonId
      );

      if (data.status === true) {
        this.toggleSidebar('create-request');
        this.requestTask.sendEvent(true);
        this.toastrService.success(data.message);
        this.blockUI.stop();
      } else {
        this.toastrService.error(data.message);
        this.blockUI.stop();
      }

    } else {
      this.toastrService.error("Formu doğru doldurunuz.");
    }
  }

  toggleSidebar(name: string): void {
    this._coreSidebarService.getSidebarRegistry(name).toggleOpen();
  }
}